import store from 'state/store';
import { addLatestProduct } from './actions';

export default {
    addLatestProduct: product => {
        store.dispatch(addLatestProduct(product));
    },
};
